import { Outlet } from "react-router-dom";
import Text from "../../Components/Text";
import Icon from "../../Components/Icon";
import ScrollWrapper from "../../Components/ScrollWrapper";
import {useNavigate} from "react-router-dom";

const AdSlot = ({ position = "left" }) => (
  <div
    className="hidden lg:flex flex-col items-center justify-start sticky top-6 self-start shrink-0"
    style={{ width: 160 }}
  >
    <div
      className="w-[160px] h-[600px] bg-gray-100 border border-dashed border-gray-300 rounded-md flex items-center justify-center text-gray-400 text-xs"
      aria-label={`Werbefläche ${position}`}
    >
      Anzeige<br />160×600
    </div>
  </div>
);

const MainLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col h-full w-full bg-white">
      {/* Navbar */}
      <div className="flex items-center justify-start p-3 gap-6 border-b bg-blue-100 border-gray-200" >
        <div className="cursor-pointer" onClick={() => navigate("/")}>
          <Icon iconName="pdf-converter-icon.png" classNames="h-12 w-12" />
        </div>
        
        <Text type="webtitle">FileForge</Text>
      </div>

      {/* Content */}
      <div className="flex-1 h-full overflow-auto">
        <div className="w-full h-full flex flex-row">
          <div className="flex flex-row h-full w-full bg-white">
            <AdSlot position="left" />

            <ScrollWrapper>
              <Outlet />
            </ScrollWrapper>

            <AdSlot position="right" />
          </div>
          {/* <Sidebar /> */}

        </div>
      </div>
    </div>
  );
};

export default MainLayout;
